import { atom } from 'jotai';
import {
  $EnableIndexForRecommend,
  $GallerySwiper,
  $MainSwiper,
  $CurrentGalleryArticle,
  $CurrentMainSlide,
  $CurrentGallerySlide,
} from '.';
import _clamp from 'lodash/clamp';

interface INestedSwiper {
  length: number;
  /**
   * current index for nested gallery swiper
   *
   * starts from 0
   */
  current: number;
}

export const $NestedSwiperSlideInfo = atom<INestedSwiper>((get) => {
  const enableIndexForRecommend = get($EnableIndexForRecommend);
  const { imageList } = get($CurrentGalleryArticle);
  const currentMainSlide = get($CurrentMainSlide);
  const currentGallerySlide = get($CurrentGallerySlide);

  if (enableIndexForRecommend) {
    return {
      length: imageList.length + 1,
      current: currentGallerySlide + currentMainSlide,
    };
  }

  return {
    length: imageList.length,
    current: currentGallerySlide,
  };
});

export const $SlideToNestedIndex = atom((get) => {
  const enableIndexForRecommend = get($EnableIndexForRecommend);
  const mainSwiper = get($MainSwiper);
  const gallerySwiper = get($GallerySwiper);

  return (index: number): void => {
    if (!mainSwiper || !gallerySwiper) {
      return;
    }

    let nextMainSwiperIndex: 1 | 0;
    if (enableIndexForRecommend) {
      nextMainSwiperIndex = index >= gallerySwiper.slides.length ? 1 : 0;
    } else {
      nextMainSwiperIndex = 0;
    }

    const nextGallerySwiperIndex = _clamp(index - nextMainSwiperIndex, 0, gallerySwiper.slides.length - 1);

    mainSwiper.slideTo(nextMainSwiperIndex);
    gallerySwiper.slideTo(nextGallerySwiperIndex);
  };
});
